import { Box, IconButton, type IconButtonProps, Typography } from "@mui/material";
import type { FC } from "react";

type ToolbarIconButtonProps = IconButtonProps & {
  "data-analytics-id": string;
  disabled?: boolean;
  label?: string;
  icon: React.JSX.Element;
  children?: React.ReactNode;
};
export const ToolbarIconButton: FC<ToolbarIconButtonProps> = (props) => {
  const { disabled, label, icon, children } = props;
  return (
    <IconButton
      sx={{ justifyContent: "start" }}
      disabled={disabled}
      {...props}
      data-analytics-id={props["data-analytics-id"]}
    >
      {label ? (
        <Box sx={{ display: "inline-flex", gap: 1, minWidth: 100 }}>
          {icon}
          <Typography sx={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
            {label}
          </Typography>
          {children}
        </Box>
      ) : (
        icon
      )}
    </IconButton>
  );
};
